<template>
  <li v-if="isFolder">
    <div class="recordingTreeFolder"
         @click="toggle">
      <span v-if="isFolder">[{{ isOpen ? '-' : '+' }}]</span>
      {{ recording.name }}
    </div>
    <ul v-show="isOpen" v-if="isFolder" class="recordingTreeList">
      <tree-item
        class="item"
        v-for="(child, index) in recording.children"
        :key="index"
        :recording="child"
      />
    </ul>
  </li>
  <li v-else>
    <div v-if="isFetching">
      <b-progress :value="100" variant="warning" :animated="true"/>
    </div>
    <div class="recordingTreeFile" @click="getFile(recording.key)" v-else>{{ recording.name }}</div>
  </li>
</template>

<script>
  import { Storage } from 'aws-amplify'

  export default {
    name: 'tree-item',
    props: {
      recording: Object
    },
    data: function () {
      return {
        isOpen: false,
        isFetching: false
      }
    },
    computed: {
      isFolder: function () {
        return this.recording.size === 0
      }
    },
    methods: {
      toggle: function () {
        if (this.isFolder) {
          this.isOpen = !this.isOpen
        }
      },
      getFile (fileKey) {
        this.isFetching = true
        Storage.get(fileKey, { download: true }).then(result => {
          console.log(result)
          let mimeType = result.ContentType

          let fileName = result.Metadata.filename
          if (mimeType !== 'audio/mp3') {
            throw new TypeError('Unexpected MIME Type')
          }

          try {
            let blob = new Blob([result.Body], { type: mimeType })

            //downloading the file depends on the browser
            //IE handles it differently than chrome/webkit
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, fileName)
            } else {
              let objectUrl = URL.createObjectURL(blob)
              let link = document.createElement('a')
              link.href = objectUrl
              link.setAttribute('download', fileName)
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
              this.isFetching = false
            }
          } catch (exc) {
            console.log('Save Blob method failed with the following exception.')
            console.log(exc)
          }

        })
      }
    }
  }
</script>
